import { getControl } from "./form.selector";
import { RxCoverageApplicationState } from "../RxCoverageApplication";

export const getIsUnderwritingQuestionsValid = (
  state: RxCoverageApplicationState
) => getControl(state, "underwritingQuestions")?.valid;
